import React from "react";
import Button from "../Button";
import T from "../../i18n/Text";

interface Props {
    backToDetails: () => void;
    nextToPlay: () => void;
    nextDisabled: boolean;
    backButtonLabelPath?: string;
    nextButtonLabelPath?: string;
}

const ConfigActionButtons = ({
                                 backToDetails,
                                 nextToPlay,
                                 nextDisabled= false,
                                 backButtonLabelPath = 'games.buttons.back',
                                 nextButtonLabelPath= 'games.buttons.next'
}: Props) => <div className="h-[144px] md:h-fit w-full md:w-[473px] m-auto flex flex-col md:flex-row justify-between">
    <Button type="secondary" onClick={backToDetails} name="game-config-back"><T path={backButtonLabelPath} /></Button>
    <Button type="primary" disabled={nextDisabled} onClick={nextToPlay} name="game-config-next"><T path={nextButtonLabelPath} /></Button>
</div>;

export default ConfigActionButtons;
